import React from 'react';
import PropTypes from 'prop-types';

import * as ActPropTypes from 'types/act';

export default function EligibleContacts({ eligibleFriends }) {
  if (!eligibleFriends.length) {
    return (
      <option
        className="option--disabled-but-legible"
        value="-1"
        disabled
      >
        No eligible contacts
      </option>
    );
  }
  return eligibleFriends.map(({ id, name, userName }) => (
    <option
      key={id}
      value={id}
    >
      {`${name} (${userName})`}
    </option>
  ));
}

EligibleContacts.propTypes = {
  eligibleFriends: PropTypes.arrayOf(ActPropTypes.eligibleFriend).isRequired,
};